import React, { useEffect, useState, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { toast } from "react-toastify";
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles(() => ({
  root: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 16,
  },
}));

const SSOCallback = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [error, setError] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("code");

    if (!code) {
      setError("Código de autorização não encontrado");
      setTimeout(() => history.push("/login"), 2000);
      return;
    }

    const exchangeCode = async () => {
      try {
        const { data } = await api.post("/auth/sso-callback", { code });

        // Store auth data same way as regular login
        localStorage.setItem("token", JSON.stringify(data.token));
        localStorage.setItem("companyId", data.user.companyId);
        localStorage.setItem("userId", data.user.id);
        api.defaults.headers.Authorization = `Bearer ${data.token}`;

        toast.success("Login SSO realizado com sucesso!");
        // Full reload to re-initialize auth context
        window.location.href = "/tickets";
      } catch (err) {
        console.error("SSO callback error:", err);
        setError("Falha na autenticação SSO");
        setTimeout(() => history.push("/login"), 3000);
      }
    };

    exchangeCode();
  }, [location.search, history]);

  return (
    <div className={classes.root}>
      {error ? (
        <Typography color="error">{error}</Typography>
      ) : (
        <>
          <CircularProgress size={48} />
          <Typography>Autenticando via SSO...</Typography>
        </>
      )}
    </div>
  );
};

export default SSOCallback;
